<template>
  <v-text-field
    :label="label"
    v-model="inputData"
    class="ma-0 grey_text_light--text"
    :suffix="suffix"
    :prefix="prefix"
    :type="type"
    :disabled="disabled"
    :rules="rules"
    :hint="hint"
    :counter="counter"
    :clearable="clearable"
    :clear-icon="clearIcon"
    :placeholder="placeholder"
    :append-icon="appendIcon"
    :prepend-inner-icon="prependInnerIcon"
    :list="list"
    flat
    solo
    single-line
    :hide-details="!hint"
    :height="height"
    :style="{
      width: width + 'px'
    }"
    @click:append="$emit(`click:append`)"
    @click:clear="$emit(`click:clear`)"
  ></v-text-field>
</template>

<script>
export default {
  name: 'Input',
  model: { prop: 'textData', event: 'input' },
  props: {
    textData: { type: [String, Number], required: true },
    label: { type: String, required: false, default: null },
    placeholder: { type: String, required: false, default: null },
    suffix: { type: String, required: false, default: null },
    prefix: { type: String, required: false, default: null },
    type: { type: String, required: false, default: 'text' },
    hint: { type: String, required: false, default: null },
    appendIcon: { type: String, required: false, default: null },
    prependInnerIcon: { type: String, required: false, default: null },
    disabled: { type: Boolean, required: false, default: false },
    clearable: { type: Boolean, required: false, default: false },
    clearIcon: { type: String, required: false, default: 'clear' },
    counter: { type: [String, Number, Boolean], required: false, default: false },
    width: { type: [String, Number], required: false, default: 480 },
    height: { type: [String, Number], required: false, default: 32 },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    list: { type: String, required: false, default: null }
  },
  computed: {
    inputData: {
      get() {
        return this.textData;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style scoped>
.v-input {
  border: 1px solid #ced6e0;
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  border-radius: 5px;
}
.v-input >>> .v-input__control {
  min-height: 28px;
}
.v-input >>> .v-input__control .v-input__slot {
  border-radius: 5px;
}
.v-input >>> .v-input__control .v-input__slot .v-input__append-inner .v-input__icon .primary--text {
  color: #16214e !important;
}
.v-input >>> .v-input__control .v-input__slot .v-text-field__slot input {
  font-size: 12px;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/_atoms/inputs/Input.vue